/**
 * Kinh phí trong tham số in báo cáo
 * NVTUAN1 02.11.2022
 */
export default {
  /**
   * Kinh phí thường xuyên
   */
  TX: 1,
  /**
   * Kinh phí không thường xuyên
   */
  KTX: 2,
  /**
   * Kinh phí xây dựng cơ bản
   */
  XDCB: 5,
};
